import { DefaultLogger, getWsKeyForTopicChannel, WebsocketClient, WsChannelSubUnSubRequestArg, WSClientConfigurableOptions, WsKey } from "libs/okx-api/src";
import { MarketLoggerService, WsRequestLogRow } from "./market-logger.service";
import { cloneDeep, isEqual } from "lodash-es";

export class OkxWebsocketClient extends WebsocketClient {

  constructor(options: WSClientConfigurableOptions, logger: typeof DefaultLogger, private marketLogger: MarketLoggerService) {
    super(options, logger)

    this.on('open', ({wsKey, event}) => this.logNetworkEvent(wsKey, event, 'client', 'open'))
    this.on('close', ({wsKey, event}) => this.logNetworkEvent(wsKey, event, 'client', 'close'))
    this.on('reconnected', ({wsKey, event}) => this.logNetworkEvent(wsKey, event, 'client', 'reconnect'))
    this.on('update', data => this.logMessageEvent(data, 'message'))
    this.on('response', data => this.logMessageEvent(data, 'response'))
    this.on('error', data => this.logMessageEvent(data, 'error'))
  }

  hasSubscription(sub: WsChannelSubUnSubRequestArg) {
    let result = false
    this.getWsStore().getTopics(getWsKeyForTopicChannel(this.options.market, sub.channel)).forEach(t => {
      if (isEqual(t, sub)) {
        result = true
      }
    })
    return result
  }

  public override tryWsSend(wsKey: WsKey, wsMessage: string) {
    // Логирование исходящих сообщений
    let payload: any
    try {
      payload = JSON.parse(wsMessage)
      payload = this.logFilter(payload)
    } catch {
      payload = undefined
    }

    if (payload) {
      const logRow: WsRequestLogRow = {
        time: Date.now(),
        market: 'okx' as any,
        type: 'ws',
        wsKey: wsKey,
        side: 'client',
        event: 'request',
        payload: payload,
      }
      this.marketLogger.log(logRow)
    }

    return super.tryWsSend(wsKey, wsMessage)
  }

  private logFilter(payload: any): any {
    let ok = false
    if ('event' in payload) {
      ok = true
    }
    if ('arg' in payload && 'channel' in payload.arg && ['orders', 'positions'].includes(payload.arg.channel)) {
      ok = true
    }
    if (ok) {
      payload = cloneDeep(payload)
      delete payload.wsKey
      return payload
    }
    return undefined
  }

  private logNetworkEvent(wsKey: WsKey, event: any, side: WsRequestLogRow['side'], logEventName: WsRequestLogRow['event']) {
    const websoket = event.target as WebSocket
    const logRow: WsRequestLogRow = {
      time: Date.now(),
      market: 'okx',
      type: 'ws',
      wsKey: wsKey,
      side: side,
      event: logEventName,
      payload: {
        url: websoket.url
      }
    }
    this.marketLogger.log(logRow)
  }

  private logMessageEvent(data: any & {wsKey: WsKey, isWSAPIResponse?: boolean}, logEventName: WsRequestLogRow['event']) {
    const payload = this.logFilter(data)
    if (payload) {
      const logRow: WsRequestLogRow = {
        time: Date.now(),
        market: 'okx' as any,
        type: 'ws',
        wsKey: data.wsKey,
        side: 'server',
        event: logEventName,
        payload: payload
      }
      if ('code' in payload) {
        logRow.apiCode = payload.code
      }
      if ('msg' in payload) {
        logRow.apiMessage = payload.msg
      }
      this.marketLogger.log(logRow)
    }
  }

}
